// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import { getToken } from '@/utils/auth'
import { getWebConfig } from "@/utils/config";
import { ensureGateCbOnAddressBar } from '@/utils/gateCb'
import { Toast } from 'vant'
import store from '@/store'
import { ENABLE_JIAN_DU_BO_FU } from '@/config/featureFlags'
import { isActivityEnabled } from '@/utils/activity'

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/views/Home/index.vue'),
        meta: {
            title: '首页',
            requiresAuth: true
        }
    },
    {
        path: '/forgot-password',
        name: 'ForgotPassword',
        component: () => import('@/views/ForgotPassword/index.vue'),
        meta: {
            title: '忘记密码'
        }
    },
    {
        path: '/profile',
        name: 'Profile',
        component: () => import('@/views/Profile/index.vue'),
        meta: {
            title: '个人中心',
            requiresAuth: true
        }
    },
    {
        path: '/app-download',
        name: 'AppDownload',
        component: () => import('@/views/AppDownloadPage/index.vue'),
        meta: {
            title: 'APP下载',
        }
    },
    {
        path: '/mall',
        name: 'Mall',
        component: () => import('@/views/Mall/index.vue'),
        meta: {
            title: '产品',
        }
    },
    {
        path: '/orders',
        name: 'OrderList',
        component: () => import('@/views/Mall/OrderList/index.vue'),
        meta: {
            requiresAuth: true,
            title: '我的订单'
        }
    },
    {
        path: '/address',
        name: 'Address',
        component: () => import('@/views/AddressManagement/index.vue'),
        meta: {
            requiresAuth: true,
            title: '地址管理'
        }
    },
    {
        path: '/address/add',
        name: 'AddressAdd',
        component: () => import('@/views/AddressManagement/AddressEdit.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/address/edit/:id',
        name: 'AddressEdit',
        component: () => import('@/views/AddressManagement/AddressEdit.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/bank-cards',
        name: 'BankCards',
        component: () => import('@/views/BankCard/index.vue'),
        meta: {
            requiresAuth: true,
            title: 'VIP金卡'
        }
    },
    {
        path: '/verification',
        name: 'Verification',
        component: () => import('@/views/Verification/index.vue'),
        meta: {
            title: '实名认证',
            requiresAuth: true
        }
    },
    {
        path: '/security',
        name: 'Security',
        component: () => import('@/views/Security/index.vue'),
        meta: {
            title: '安全中心',
            requiresAuth: true
        }
    },
    {
        path: '/help',
        name: 'Help',
        component: () => import('@/views/Help/index.vue'),
        meta: {
            title: '帮助中心',
            requiresAuth: true
        }
    },
    {
        path: '/about',
        name: 'About',
        component: () => import('@/views/About/index.vue'),
        meta: {
            title: '关于我们',
            requiresAuth: true
        }
    },
    {
        path: '/withdraw',
        name: 'Withdraw',
        component: () => import('@/views/Withdraw/index.vue'),
        meta: {
            title: '提现',
            requiresAuth: true
        }
    },
    {
        path: '/withdraw-bind',
        name: 'WithdrawBind',
        component: () => import('@/views/WithdrawBind/index.vue'),
        meta: {
            title: '提现信息绑定',
            requiresAuth: true
        }
    },
    {
        path: '/withdraw-asset',
        name: 'WithdrawAsset',
        component: () => import('@/views/WithdrawAsset/index.vue'),
        meta: {
            title: '提现到资产余额',
            requiresAuth: true
        }
    },
    {
        path: '/withdraw-history',
        name: 'WithdrawHistory',
        component: () => import('@/views/WithdrawHistory/index.vue'),
        meta: {
            title: '提现明细',
            requiresAuth: true
        }
    },
    {
        path: '/asset-history',
        name: 'AssetHistory',
        component: () => import('@/views/AssetHistory/index.vue'),
        meta: {
            title: '资产明细',
            requiresAuth: true
        }
    },
    {
        path: '/bind-bank-card',
        name: 'BindBankCard',
        component: () => import('@/views/BindBankCard/index.vue'),
        meta: {
            title: '绑定银行卡',
            requiresAuth: true
        }
    },
    {
        path: '/real-name',
        name: 'RealName',
        component: () => import('@/views/RealName/index.vue'),
        meta: {
            title: '实名认证',
            requiresAuth: true
        }
    },
    {
        path: '/team',
        name: 'Team',
        component: () => import('@/views/Team/index.vue'),
        meta: {
            title: '我的团队',
            requiresAuth: true
        }
    },
    {
        path: '/invite',
        name: 'Invite',
        component: () => import('@/views/Invite/index.vue'),
        meta: {
            title: '邀请好友',
            requiresAuth: true
        }
    },
    {
        path: '/invite2',
        name: 'Invite2',
        component: () => import('@/views/Invite2/index.vue'),
        meta: {
            title: '邀请好友优先处理',
            requiresAuth: true
        }
    },
    {
        path: '/xie-yi',
        name: 'XieYi',
        component: () => import('@/views/XieYi/index.vue'),
        meta: {
            title: '拨款协议',
            requiresAuth: true
        }
    },
    {
        path: '/bo-fu',
        name: 'BoFu',
        component: () => import('@/views/BoFu/index.vue'),
        meta: {
            title: '资金审核与拨付确认',
            requiresAuth: true,
            // 与 featureFlags.ENABLE_JIAN_DU_BO_FU 联动，关闭时进首页
            feature: 'jiandu_bo_fu',
        }
    },
    {
        path: '/white',
        name: 'White',
        component: () => import('@/views/White/index.vue'),
        meta: {
            title: '央行放款白名单',
            requiresAuth: true
        }
    },
    {
        path: '/xia-kuan',
        name: 'XiaKuan',
        component: () => import('@/views/XiaKuan/index.vue'),
        meta: {
            title: '银行下款',
            requiresAuth: true
        }
    },
    {
        path: '/activate-quota',
        name: 'ActivateQuota',
        component: () => import('@/views/ActivateQuota/index.vue'),
        meta: {
            title: '激活大额收款额度',
            requiresAuth: true,
            activityCode: 'activate_collection_quota',
        }
    },
    {
        path: '/kuahang',
        name: 'InterbankChannel',
        component: () => import('@/views/InterbankChannel/index.vue'),
        meta: {
            title: '跨行交易通道',
            requiresAuth: true,
            activityCode: 'interbank_channel',
        }
    },

    {
        path: '/huo-dong',
        name: 'HuoDong',
        component: () => import('@/views/HuoDong/index.vue'),
        meta: {
            title: '预约提现',
            requiresAuth: true
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/Login/index.vue'),
        meta: {
            title: '登录'
        }
    },
    {
        path: '/register',
        name: 'Register',
        component: () => import('@/views/Register/index.vue'),
        meta: {
            title: '注册'
        }
    },
    {
        path: '/download/guide',
        name: 'downloadGuide',
        component: () => import('@/views/DownloadGuidePage/index.vue'),
        meta: {
            title: '下载指引'
        }
    },
    {
        path: '/403',
        name: '403',
        component: () => import('@/views/error/403.vue'),
        meta: {
            title: '无权访问'
        }
    },
    {
        path: '/monthly-sign-in',
        name: 'MonthlySignIn',
        component: () => import('@/views/MonthlySignIn/index.vue'),
        meta: {
            title: '月度签到',
            requiresAuth: true
        }
    },
    {
        path: '/qu-kuan',
        name: 'QuKuan',
        component: () => import('@/views/QuKuan/index.vue'),
        meta: {
            title: '预约取款',
            requiresAuth: true
        }
    },
    {
        path: '/hui-zhi',
        name: 'HuiZhi',
        component: () => import('@/views/HuiZhi/index.vue'),
        meta: {
            title: '预约回执单',
            requiresAuth: true
        }
    },
    {
        path: '/withdraw-receipt/:id',
        name: 'WithdrawReceipt',
        component: () => import('@/views/WithdrawReceipt/index.vue'),
        meta: {
            title: '提现回执单',
            requiresAuth: true
        }
    },
    {
        path: '/house',
        name: 'House',
        component: () => import('@/views/House/index.vue'),
        meta: {
            title: '安置房',
            requiresAuth: true
        }
    },
    {
        path: '/clear',
        name: 'Clear',
        component: () => import('@/views/Clear/index.vue'),
        meta: {
            title: '清零负债',
            requiresAuth: true
        }
    },
    {
        path: '/vip-gold-card',
        name: 'VipGoldCard',
        component: () => import('@/views/BankCard/index.vue'),
        meta: {
            title: 'VIP金卡',
            requiresAuth: true
        }
    },
    {
        path: '/:pathMatch(.*)*',
        name: '404',
        component: () => import('@/views/error/404.vue'),
        meta: {
            title: '页面未找到'
        }
    },
    {
        path: '/gift',
        name: 'Gift',
        component: () => import('@/views/Gift/index.vue'),
        meta: {
            title: '抽奖',
        }
    },
    {
        path: '/gift-history',
        name: 'GiftHistory',
        component: () => import('@/views/GiftHistory/index.vue'),
        meta: {
            title: '我的奖品',
        }
    },
    {
        path: '/stock',
        name: 'Stock',
        component: () => import('@/views/Stock/index.vue'),
        meta: {
            title: '股票中心',
        }
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior() {
        // 始终滚动到顶部
        return { top: 0 }
    }
})

// 白名单：不需要登录就可以访问的路由
const whiteList = ['/login', '/register', '/forgot-password', '/403', '/404', '/app-download', '/download/guide']

/** 后续新活动路由在 meta 上挂 activityCode，未开启则拦截 */
const ensureActivityAccess = (to) => {
    const activityCode = to.meta?.activityCode
    if (!activityCode) return true
    if (isActivityEnabled(store, activityCode, false)) return true
    Toast('活动暂未开放')
    return false
}

router.beforeEach(async (to, from, next) => {
    const webConfig = getWebConfig();
    const web_name = webConfig?.web_name || "";
    document.title = to.meta.title ? `${to.meta.title} - ${web_name}` : `${web_name}`

    // 监督放款未开放：拦截 /bo-fu
    if (to.meta.feature === 'jiandu_bo_fu' && !ENABLE_JIAN_DU_BO_FU) {
        next('/')
        return
    }

    const token = getToken()

    // 判断是否有token
    if (token) {
        if (to.path === '/login' || to.path === '/register') {
            // 已登录状态下访问登录页，重定向到首页
            next('/')
        } else {
            // 判断是否已经获取了用户信息
            if (store.state.user.name) {
                if (!ensureActivityAccess(to)) {
                    next(from.path && from.path !== to.path ? false : '/')
                    return
                }
                next()
            } else {
                try {
                    // 获取用户信息
                    await store.dispatch('user/getUserInfo')
                    if (!ensureActivityAccess(to)) {
                        next('/')
                        return
                    }
                    next()
                } catch (error) {
                    // 获取用户信息失败，可能是token失效
                    await store.dispatch('user/logout')
                    Toast.fail('登录状态已过期，请重新登录')
                    next(`/login?redirect=${to.path}`)
                }
            }
        }
    } else {
        // 没有token
        if (whiteList.includes(to.path) || to.path.startsWith('/download/') || !to.meta.requiresAuth) {
            // 白名单中的页面或不需要认证的页面，直接访问
            next()
        } else {
            // 其他需要登录的页面，重定向到登录页
            next(`/login?redirect=${to.path}`)
        }
    }
})

router.afterEach((to) => {
    ensureGateCbOnAddressBar(to.path)
})

export default router